import React from 'react'
import { useActions, useValues } from 'kea'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import Imgix from 'lib/tags/imgix'
import railsContext from 'lib/selectors/rails-context'

import MenuElement from './menu-elements'

import sceneLogic from '../logic'

const ProfileMenu = ({ menuItems, avatar, lastOnRight }) => {
  const { profileMenu } = useValues(sceneLogic)
  const { enableIsProfileHovered, disableIsProfileHovered, enableIsMenuHovered, disableIsMenuHovered } =
    useActions(sceneLogic)
  const { dpr } = useSelector(railsContext)

  return (
    <div className='item profile item-with-image' style={lastOnRight ? { marginLeft: 'auto' } : null}>
      <Imgix
        className='profile-img'
        alt='profile image'
        src={avatar}
        width={28}
        height={28}
        dpr={dpr}
        style={{ display: 'block' }}
        onMouseEnter={enableIsProfileHovered}
        onMouseLeave={disableIsProfileHovered}
      />
      <MenuElement
        isActive={profileMenu}
        onMouseEnter={enableIsMenuHovered}
        onMouseLeave={disableIsMenuHovered}
        customClassName='profile-menu'
        items={menuItems}
      />
    </div>
  )
}

ProfileMenu.propTypes = {
  lastOnRight: PropTypes.bool,
  avatar: PropTypes.string,
  menuItems: PropTypes.array
}

export default ProfileMenu
